import { render, staticRenderFns } from "./PushNotificationBox.vue?vue&type=template&id=222e449f&"
import script from "./PushNotificationBox.vue?vue&type=script&lang=js&"
export * from "./PushNotificationBox.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports